/**
 * Dashboard route prefixes used to defer heavy project-context fetches.
 */

export const DASHBOARD_ROUTE_PREFIXES = [
    '/overview-dashboard',
    '/executive-dashboard',
    '/financial-management',
    '/analytics-dashboard',
    '/dashboard',
    // Project operations shell is mounted at both /project-operations and /projects/*.
    '/project-operations',
    '/projects',
    '/resource-planning',
    // Observability is a dashboard page, but it does not need per-project budget fan-out.
    '/observability',
    '/cost-dashboard',
];

/**
 * True when pathname is a dashboard page where we defer heavy project-context
 * fetches (notably per-project budget analysis fan-out).
 *
 * @param {string} pathname - React Router location.pathname
 * @returns {boolean}
 */
export const isDashboardShellPath = (pathname) => (
    DASHBOARD_ROUTE_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
);

const PROJECT_OPERATIONS_PREFIXES = [
    '/project-operations',
    '/projects',
];

/**
 * True when per-project budget_analysis fan-out should be skipped (KPI shells only).
 * Project operations routes still fetch budget alerts for the wedge workflow.
 *
 * @param {string} pathname - React Router location.pathname
 * @returns {boolean}
 */
export const defersProjectBudgetFanOut = (pathname) => {
    const isProjectOperations = PROJECT_OPERATIONS_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    );
    if (isProjectOperations) {
        return false;
    }
    return isDashboardShellPath(pathname);
};

/**
 * Resource planning needs full resource-optimization payloads.
 *
 * @param {string} pathname - React Router location.pathname
 * @returns {boolean}
 */
export const isResourcePlanningPath = (pathname) => (
    pathname === '/resource-planning' || pathname.startsWith('/resource-planning/')
);

/** Routes where UnifiedPSADashboard owns utilization date-range fetches. */
export const UNIFIED_PSA_DASHBOARD_PREFIXES = [
    '/executive-dashboard',
    '/financial-management',
];

/**
 * True on executive/financial shells that call getUtilizationMetrics with timeline params.
 *
 * @param {string} pathname - React Router location.pathname
 * @returns {boolean}
 */
export const isUnifiedPsaDashboardPath = (pathname) => (
    UNIFIED_PSA_DASHBOARD_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
);
